import { ServerDateContext } from 'contexts/ServerDateContext'
import { useContext } from 'react'

export function useServerDate() {
    const context = useContext(ServerDateContext)
    if (!context) {
        throw new Error('useServerDate debe usarse dentro de un ServerDateContext')
    }
    return context
}
